import type { Idl, Program } from '@coral-xyz/anchor';
import type { MarketAccount } from './types.js';

/** Layout 18 appended the one-byte `paused` flag without moving any earlier offset. */
const PAUSED_FLAG_BYTES = 1;

/**
 * Decode a Market of either deployed layout. Layout-17 accounts predate the
 * `paused` flag and are exactly one byte short; they are read as not paused.
 * Any other length is decoded as-is so a malformed account still fails.
 */
export function decodeMarketAccount(program: Program<Idl>, data: Buffer): MarketAccount {
  const missing = program.coder.accounts.size('market') - data.length;
  const full =
    missing === PAUSED_FLAG_BYTES ? Buffer.concat([data, Buffer.alloc(PAUSED_FLAG_BYTES)]) : data;
  return program.coder.accounts.decode<MarketAccount>('market', full);
}
